import { boolean, nullable, number, object, string } from "superstruct";

import CustomerSchema from "./CustomerSchema";

const AnswerSchema = object({
    id: number(),
    customer: nullable(CustomerSchema),
    productId: number(),
    body: string(),
    createdAt: string(),
    questionId: number(),
    isAdminReplied: boolean(),
    shopName: string(),
});

export default AnswerSchema;
